export const ROLES_SLIDING_CAROUSEL_HEIGHT = 655;

export const EMPTY_STATE = [{ type: 'text', value: 'No results found.' }];
